export const HEADER_TEXT_COLOR = '#171717'
export const SECONDARY_COLOR = '#E8E8E8'
export const MAIN_BACKGROUND = '#E5E5E5'

export const LIGHT_COLOR = '#FFFFFF'